<template>
  <span class="yCenter pa-5">
    <div class="mr-5">
      {{ $t('sale.sale_sale-number') + ':' + items.transaction.controlNumber }}
    </div>
    <div class="mr-16"></div>
    <div class="mr-5" v-if="items.paymentDate">
      {{ $t('sale.sale_payment-date') + ':' + items.paymentDate }}
    </div>
    <div class="mr-5" v-if="items.loadingDate">
      {{ $t('loading.loading_loading-date') + ':' + items.loadingDate }}
    </div>
    <div class="mr-5" v-if="items.compDate">
      {{ $t('sale.sale_completion-date') + ':' + items.compDate }}
    </div>
  </span>
</template>
<script>
export default {
  components: {},
  props: {
    items: { default: {} }
  },
  data: () => ({}),
  methods: {},
  computed: {}
}
</script>
<style lang="scss" scoped></style>
